const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';

export const endpoints = {
  login: `${API_BASE_URL}/api/login/`,
  signup: `${API_BASE_URL}/api/signup/`,
  me: `${API_BASE_URL}/api/me/`,
  notificationOptInPopupShown: `${API_BASE_URL}/api/me/notification-opt-in-popup-shown/`,
  updateProfile: `${API_BASE_URL}/api/me/`,
  timezones: `${API_BASE_URL}/api/timezones/`,
  forgotPassword: `${API_BASE_URL}/api/forgot_password/`,
  resetPassword: `${API_BASE_URL}/api/reset_password/`,
  changePassword: `${API_BASE_URL}/api/change_password/`,
  userprofiles: `${API_BASE_URL}/api/user-profiles/`,
  change_password: `${API_BASE_URL}/api/change_password/`,
  plans: `${API_BASE_URL}/api/plans/`,
  site_settings: `${API_BASE_URL}/api/site-settings/`,
  subscribe: `${API_BASE_URL}/api/subscribe/`,
  cancel: `${API_BASE_URL}/api/cancel/`,
  pause_subscription: `${API_BASE_URL}/api/pause/`,
  resume_subscription: `${API_BASE_URL}/api/resume/`,
  verify_payment: `${API_BASE_URL}/api/verify_payment/`,
  endTrialSubscription: `${API_BASE_URL}/api/end_trial/`,
  // Canonical subscription status endpoint (backend: /api/subscription/info/)
  subscriptionStatus: `${API_BASE_URL}/api/subscription/info/`,
  properties: `${API_BASE_URL}/mls_integration/properties/`,
  delete_property: (id) =>
    `${API_BASE_URL}/mls_integration/properties/${id}/delete/`,


  service_listings: `${API_BASE_URL}/mls_integration/service-listings/`,
  propertylisttype: `${API_BASE_URL}/mls_integration/propertylisttype/`,
  keyfeatures: `${API_BASE_URL}/mls_integration/keyfeatures/`,
  address_lookup: `${API_BASE_URL}/mls_integration/address-lookup/`,
  mls_uploads: `${API_BASE_URL}/mls_integration/uploads/`,
  delete_keyfeature: `${API_BASE_URL}/mls_integration/keyfeatures/`,
  // db_states: `https://mylistiq.com/backend/agent_db/states/`,
  // db_cities: `https://mylistiq.com/backend/agent_db/cities/`,
  db_states: `${API_BASE_URL}/agent_db/states/`,
  db_cities: `${API_BASE_URL}/agent_db/cities/`,
  suggest_nearest_cities: `${API_BASE_URL}/agent_db/cities/suggest/`,
  db_counties_by_state: (stateId) => `${API_BASE_URL}/agent_db/states/${stateId}/counties/`,
  suggest_nearest_counties: `${API_BASE_URL}/agent_db/counties/suggest/`,
  image_change: `${API_BASE_URL}/mls_integration/properties/`,

  custom_templates: `${API_BASE_URL}/api/custom-templates/`,
  get_custom_template_by_id: (id) => `${API_BASE_URL}/api/custom-templates/${id}/`,
  createCampaign: `${API_BASE_URL}/campaign/campaigns/`,
  listCampaigns: `${API_BASE_URL}/campaign/campaigns/`,
  generate_subject: `${API_BASE_URL}/campaign/generate/subject/`,
  generate_description: `${API_BASE_URL}/campaign/generate/description/`,
  predict_rates: `${API_BASE_URL}/campaign/api/predict-rates/`,
  improve_text: `${API_BASE_URL}/campaign/improve-text/`,
  correct_grammar: `${API_BASE_URL}/campaign/correct-grammar/`,
  enhance_image: `${API_BASE_URL}/campaign/enhance-image/`,
  campaign_counts: `${API_BASE_URL}/campaign/count/`,
  getCampaignById: (id) => `${API_BASE_URL}/campaign/campaigns/${id}/`,
  updateCampaignById: (id) => `${API_BASE_URL}/campaign/campaigns/${id}/`,
  cancelCampaignById: (id) => `${API_BASE_URL}/campaign/campaigns/${id}/cancel/`,
  subscription_info: `${API_BASE_URL}/api/subscription/info/`,
  add_ons: `${API_BASE_URL}/api/addons/`,
  campaign_add_ons: `${API_BASE_URL}/api/addons/campaign/`,
  association_add_ons: `${API_BASE_URL}/api/addons/association/`,
  addons_subscribe: `${API_BASE_URL}/api/addons/subscribe/`,
  addon_success: `${API_BASE_URL}/api/addons/success/`,

  deleteAccount: `${API_BASE_URL}/api/delete-account/`,
  agent_user: `${API_BASE_URL}/agent_db/agentuser/`,
  associations: `${API_BASE_URL}/agent_db/associations/`,

  facebook_auth: `${API_BASE_URL}/campaign/social/facebook/login/`,
  instagram_auth: `${API_BASE_URL}/campaign/social/instagram/login/`,
  social_status: `${API_BASE_URL}/campaign/social/status/`,
  instagram_from_facebook: `${API_BASE_URL}/campaign/social/instagram/from-facebook/`,
  select_social_page: `${API_BASE_URL}/campaign/social/select-page/`,

  facebook_connect: `${API_BASE_URL}/campaign/social/facebook/`,
  instagram_connect: `${API_BASE_URL}/campaign/social/instagram/`,
  disconnect_social: (platform) => `${API_BASE_URL}/campaign/social_auth/social/${platform}/`,
  facebook_post: `${API_BASE_URL}/campaign/social/post/facebook/`,
  instagram_post: `${API_BASE_URL}/campaign/social/post/instagram/`,
  instagram_publish: `${API_BASE_URL}/campaign/social/post/instagram/publish/`,
  upload_generated_flyer: `${API_BASE_URL}/campaign/api/upload/generated-flyer/`,
  image_proxy: `${API_BASE_URL}/campaign/image-proxy/`,
  upload_image: `${API_BASE_URL}/api/upload/image/`,
  contact_groups: `${API_BASE_URL}/agent_db/contact-groups/`,
  email_proof: `${API_BASE_URL}/campaign/email/send-proof/`,

  send_service_proof: `${API_BASE_URL}/campaign/send-service-proof-email/`,

  notifications: `${API_BASE_URL}/api/notifications/`,
  notificationsUnread: `${API_BASE_URL}/api/notifications/unread/`,
  notificationsUnreadCount: `${API_BASE_URL}/api/notifications/unread_count/`,
  notificationMarkRead: (id) => `${API_BASE_URL}/api/notifications/${id}/mark_read/`,
  notificationsMarkAllRead: `${API_BASE_URL}/api/notifications/mark_all_read/`,
  notificationsClearAll: `${API_BASE_URL}/api/notifications/clear_all/`,
  notificationDetail: (id) => `${API_BASE_URL}/api/notifications/${id}/`,
  draft_property: `${API_BASE_URL}/mls_integration/properties/draft/`,
  draft_property_exists: `${API_BASE_URL}/mls_integration/properties/draft/exists/`,
  draft_property_publish: `${API_BASE_URL}/mls_integration/properties/draft/publish/`,

  // Campaign Draft endpoints (DraftCampaign model in campaign app)
  campaign_drafts: `${API_BASE_URL}/campaign/drafts/`,
  campaign_drafts_save: `${API_BASE_URL}/campaign/drafts/save/`,
  campaign_draft_delete: (id) => `${API_BASE_URL}/campaign/drafts/${id}/`,
  campaign_draft_launch: (id) => `${API_BASE_URL}/campaign/drafts/${id}/launch/`,
  admin_agents: `${API_BASE_URL}/agent_db/admin-agents/`,
  admin_agents_unsubscribe: `${API_BASE_URL}/agent_db/admin-agents/unsubscribe/`,
  contact: `${API_BASE_URL}/mls_integration/contact/`,

  // Flyer Control (superuser-only) — leads search/filter, validation, history, launch/cancel
  flyer_leads: `${API_BASE_URL}/campaign/flyer/leads/`,
  flyer_meta: `${API_BASE_URL}/campaign/flyer/meta/`,
  flyer_validate: `${API_BASE_URL}/campaign/flyer/validate/`,
  flyer_validation_quota: `${API_BASE_URL}/campaign/flyer/validation-quota/`,
  flyer_validate_bulk_start: `${API_BASE_URL}/campaign/flyer/validate-bulk/`,
  flyer_validate_bulk_active: `${API_BASE_URL}/campaign/flyer/validate-bulk/active/`,
  flyer_validate_bulk_pending: `${API_BASE_URL}/campaign/flyer/validate-bulk/pending/`,
  flyer_validate_bulk_pending_emails: `${API_BASE_URL}/campaign/flyer/validate-bulk/pending/emails/`,
  flyer_validate_bulk_job_pending_emails: (jobId) => `${API_BASE_URL}/campaign/flyer/validate-bulk/${jobId}/pending-emails/`,
  flyer_validate_bulk_status: (jobId) => `${API_BASE_URL}/campaign/flyer/validate-bulk/${jobId}/`,
  flyer_validation_history: `${API_BASE_URL}/campaign/flyer/validation-history/`,
  flyer_history: `${API_BASE_URL}/campaign/flyer/history/`,
  flyer_jobs: `${API_BASE_URL}/campaign/flyer/jobs/`,
  flyer_send: `${API_BASE_URL}/campaign/send-flyer-email/`,
  flyer_cancel: (id) => `${API_BASE_URL}/campaign/flyer/${id}/cancel/`,
  flyer_status: (id) => `${API_BASE_URL}/campaign/flyer/${id}/status/`,
  flyer_csv_upload: `${API_BASE_URL}/campaign/flyer/csv-upload/`,
  flyer_manual_emails: `${API_BASE_URL}/campaign/flyer/manual-emails/`,
  flyer_preview: `${API_BASE_URL}/campaign/flyer/preview/`,

  deactivate_account: `${API_BASE_URL}/api/deactivate-account/`,
  request_account_activation: `${API_BASE_URL}/api/request-activation/`,
  confirm_account_activation: (uidb64, token) => `${API_BASE_URL}/api/activate-account/${uidb64}/${token}/`,
    replyToSender: `${API_BASE_URL}/api/reply-to-sender/`,
    replyToSenderContext: `${API_BASE_URL}/api/reply-to-sender/context/`,
};
